/**
 * The hint (docs/HINTS-LAYOUT-TUTORIAL.md A1.2): Tibbs says the hard bot's
 * advice in one line, in the last-card tip's bubble docked over the me bar, so
 * it never covers a pile or a card. The × (or H) hides it.
 */
import { Tibbs } from '../Art';
import { IconClose } from '../Icons';

export function HintBubble({ text, onClose }: { text: string; onClose: () => void }) {
  return (
    <div className="tip-bubble hint" role="note" aria-label="Hint">
      <Tibbs pose="point" size={48} className="tip-tibbs" />
      <p className="tip-text">{text}</p>
      <button type="button" className="icon-btn tip-x" aria-label="Hide the hint" onClick={onClose}>
        <IconClose size={16} />
      </button>
    </div>
  );
}
